export const PRODUCT_TYPE_TO_PAGE_TYPE: Record<string, string> = {
    'collect-emails': 'lead-magnet',
    'custom-product': 'fulfillment',
    'digital-product': 'digital-download',
    'coaching-call': 'meeting',
    'external-links': 'link',
    community: 'community',
    ecourse: 'course',
    'recurring-membership': 'membership',
    webinar: 'webinar',
    'stan-affiliate-link': 'stan-referral-link',
} as const;

export type ProductType = keyof typeof PRODUCT_TYPE_TO_PAGE_TYPE;

export type PageType = (typeof PRODUCT_TYPE_TO_PAGE_TYPE)[ProductType];
